import {
  getTokenSymbol,
  getTokenDecimals,
} from '@blockcatio/tabby-library/lib/utilities/tokenUtilities';
import retry from '@blockcatio/tabby-library/lib/utilities/retry';
import { ZERO_ADDRESS } from '@blockcatio/tabby-library/lib/constants';
import safeToBn from '@blockcatio/tabby-library/lib/utilities/safeToBn';

import { getTokenListByName } from '../selectors/token';
import {
  CUSTOM_TOKEN_ADDED,
  TOKENS_LOCAL_LOADED,
  TOKEN_ADDRESS_CHANGE,
  TOKEN_ALLOWANCE_UPDATE,
  TOKEN_ALLOWANCE_UPDATE_FAILED,
  TOKEN_BALANCE_UPDATE,
  TOKEN_BALANCE_UPDATE_FAILED,
  TOKEN_AUTHORIZATION_START,
  TOKEN_AUTHORIZATION_ABORTED,
  TOKEN_AUTHORIZATION_SUBMITTED,
  TOKEN_AUTHORIZATION_FAILED,
  TOKEN_INFO_UPDATE,
  TOKEN_INFO_UPDATE_FAILED,
} from '../actionTypes';

export const tokensLocallyLoaded = localTokenList => ({
  type: TOKENS_LOCAL_LOADED,
  localTokenList,
});

export const addCustomToken = ({
  name, symbol, decimals, address,
}) => ({
  type: CUSTOM_TOKEN_ADDED,
  name,
  symbol,
  decimals,
  address,
});

export const tokenAddressChange = address => ({
  type: TOKEN_ADDRESS_CHANGE,
  address,
});

export const tokenAllowanceUpdate = allowance => ({
  type: TOKEN_ALLOWANCE_UPDATE,
  allowance,
});

export const tokenAllowanceUpdateFailed = error => ({
  type: TOKEN_ALLOWANCE_UPDATE_FAILED,
  error,
});

export const tokenBalanceUpdate = balance => ({
  type: TOKEN_BALANCE_UPDATE,
  balance,
});

export const tokenBalanceUpdateFailed = error => ({
  type: TOKEN_BALANCE_UPDATE_FAILED,
  error,
});

export const authorizeTokenStart = () => ({
  type: TOKEN_AUTHORIZATION_START,
});

export const authorizeTokenSubmitted = transactionHash => ({
  type: TOKEN_AUTHORIZATION_SUBMITTED,
  transactionHash,
});

export const authorizeTokenConfirmed = transactionHash => ({
  type: 'TOKEN_AUTHORIZATION_CONFIRMED',
  transactionHash,
});

export const authorizeTokenRejected = transactionHash => ({
  type: 'TOKEN_AUTHORIZATION_REJECTED',
  transactionHash,
});

export const authorizeTokenFailed = error => ({
  type: TOKEN_AUTHORIZATION_FAILED,
  error,
});

export const authorizeTokenAborted = () => ({
  type: TOKEN_AUTHORIZATION_ABORTED,
});

export const authorizeToken = (amount, tokenAddress, gasPrice, viewOptions = {}) => async (
  dispatch,
  getState,
  { dynamicToken, ethGateway, errorReporter },
) => {
  const {
    account: { address },
    app: { payContractAddress: spenderAddress },
  } = getState();
  const tokenList = getTokenListByName(getState());

  try {
    return await ethGateway.process(getState, {
      create: () =>
        dynamicToken.authorizeTransaction(
          spenderAddress,
          amount,
          address,
          tokenAddress,
          getTokenSymbol(tokenList, tokenAddress),
          getTokenDecimals(tokenList, tokenAddress),
          gasPrice,
        ),
      onStart: () => dispatch(authorizeTokenStart()),
      onSuccess: transactionHash => dispatch(authorizeTokenSubmitted(transactionHash)),
      onError: error => dispatch(authorizeTokenFailed(error)),
      onAbort: () => dispatch(authorizeTokenAborted()),
      viewOptions,
    });
  } catch (error) {
    errorReporter(error);
    return null;
  }
};

export const validateTokenAddress = address => async (dispatch, getState, { eth }) =>
  eth.isAddressValidContract(address);

export const fetchTokenBalance = tokenAddress => (dispatch, getState, { dynamicToken, eth }) => {
  const {
    account: { address },
  } = getState();
  if (tokenAddress === ZERO_ADDRESS) {
    return retry(() => eth.fetchBalance(address));
  }

  return retry(() => dynamicToken.fetchBalance(address, tokenAddress));
};

export const fetchTokenAllowance = tokenAddress => (dispatch, getState, { dynamicToken }) => {
  const {
    account: { address },
    app: { payContractAddress: spenderAddress },
  } = getState();
  if (tokenAddress === ZERO_ADDRESS) {
    return safeToBn(0);
  }

  return retry(() => dynamicToken.fetchAllowance(address, spenderAddress, tokenAddress));
};

export const tokenInfoUpdate = tokens => ({
  type: TOKEN_INFO_UPDATE,
  tokens,
});

export const tokenInfoUpdateFailed = error => ({
  type: TOKEN_INFO_UPDATE_FAILED,
  error,
});



// WEBPACK FOOTER //
// ./src/actions/token.js